import React from 'react';
import useStyles from 'components/Scenarios/Styles';
import { Card, Typography, Box } from '@material-ui/core';
import useGetViewPortDimensions from 'hooks/useGetViewPortDimensions';

const GenericScenario = ({ scenarioId, image, title, description, onClick, notHover, onHover, hoveredScenarioId, tabSelected, backgroundPosition , italics=false}) => {
  const classes = useStyles();
  const { isMobile } = useGetViewPortDimensions();

  const style = {
    cardBackground: {
      backgroundImage: `url(${image})`,
      backgroundSize: 'auto 100%',
      backgroundRepeat: 'no-repeat',
      backgroundPosition: backgroundPosition,
    },
  };

  function getClassList() {
    let descriptionClass = classes.notDisplayed
    if (hoveredScenarioId === scenarioId) {
      descriptionClass = classes.displayed
    }
    console.log(descriptionClass)
    return isMobile ? classes.cutCardDescriptionResponsive + " " + descriptionClass : classes.cutCardDescription  + " " + descriptionClass
  }
  return (
    <div onMouseEnter={() => onHover()} onMouseLeave={() => notHover()} onClick={onClick}>
      <Card
        classes={{
          root:
            tabSelected === 'featured'
              ? classes.featuredScenarioCard
              : classes.scenarioCard,
        }}
        style={style.cardBackground}
      >
        <Box className={classes.scenarioCardContent}>
          <Typography
            variant="body1"
            component="div"
            className={italics? classes.cutCardTitleItalics: classes.cutCardTitle}
          >
            {title}
          </Typography>
          <div>
          <Typography
            variant="body1"
            component="div"
            className={getClassList()}
          >
            {description}
          </Typography>
          </div>
        </Box>
      </Card>
    </div>
  );
};

GenericScenario.defaultProps = {
  backgroundPosition: '50% top'
};

export default GenericScenario;
